import {
    getDataWithParams,
    uploadData,
    destroyData
} from '@/store/api/method'
const basepath = 'thesischangetopic'
const initialState = () => ({
    item: {},
    list: {},
    msg: 'Jaringan Bermasalah',
    status: 0,
    request: {
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null
    },
})
const state = initialState
const getters = {
    getData: state => state.item.data || {last_page: 0, data: [], total: 0},
    getListItem: (state) => state.item.data ? state.item.data.data : [],
    getThesis: state => state.item.thesis || {},
    getList: state => state.list || {last_page: 0, data: [], total: 0},
    getListData: (state) => state.list ? state.list.data : [],
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status
}

const actions = {
    async fetchData({
        commit, state
    }, {url, request}) {
        try {
            state.request = request
            const response = await getDataWithParams(`${basepath}/${url}`,request);
            commit('SET_ITEM', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async letterCqOnly({
        commit, state
    }, request) {
        try {
            state.request = request
            const response = await getDataWithParams(`thesis/changetopiconly`,request);
            commit('SET_LIST', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async submit({
        commit
    }, {url, data}) {
        try {
            const response = await uploadData(`${basepath}${url}`,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({
        commit
    }, url) {
        try {
            const response = await destroyData(`${basepath}/${url}`);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Mohon Periksa Kembali'
            state.status = 0
        }
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}